import { useEffect, useState } from 'react'
import usePlaysAPI from '../api/v2/PlaysAPI'

interface Props {
  audio: HTMLAudioElement
  arpMediaId: number
}

const usePlayTracking = ({ arpMediaId, audio }: Props) => {
  const [currentPlayId, setCurrentPlayId] = useState(undefined)
  const { createPlay, endPlay } = usePlaysAPI()
  const [lastPlayStartTime, setLastPlayStartTime] = useState(0)
  const [runningPlayTime, setRunningPlayTime] = useState(0)

  useEffect(() => {
    return () => {
      endTokenPlay().then(() => {
        setLastPlayStartTime(0)
        setCurrentPlayId(undefined)
        setRunningPlayTime(0)
      })
    }
  }, [arpMediaId])

  const startTokenPlay = async () => {
    if (currentPlayId) {
      return
    }

    const play = await createPlay(arpMediaId)
    setCurrentPlayId(play.id)
  }

  const endTokenPlay = async () => {
    const newRunningPlayTime = runningPlayTime + (Date.now() - lastPlayStartTime)

    if (!currentPlayId) {
      return
    }

    setRunningPlayTime(newRunningPlayTime)
    await endPlay({ playId: currentPlayId, playTimeMs: newRunningPlayTime })
  }

  const handlePlaying = () => {
    setLastPlayStartTime(Date.now())
  }

  useEffect(() => {
    audio.addEventListener('play', startTokenPlay)
    audio.addEventListener('pause', endTokenPlay)
    audio.addEventListener('ended', endTokenPlay)
    audio.addEventListener('playing', handlePlaying)
    return () => {
      audio.removeEventListener('play', startTokenPlay)
      audio.removeEventListener('pause', endTokenPlay)
      audio.removeEventListener('ended', endTokenPlay)
      audio.removeEventListener('playing', handlePlaying)
    }
  }, [startTokenPlay, endTokenPlay, handlePlaying])
}

export default usePlayTracking
